// extracted by mini-css-extract-plugin
export default {"modal":"CreateInterviewTemplateModal-module__modal__5ATai","content":"CreateInterviewTemplateModal-module__content__bZsoC"};